module.exports = __webpack_public_path__ + "static/img/contract-300x300.a883cae9.gif";